import { ApiService } from "@/api";

export const MCORE_SOURCE = {
  fetch: (params) => ApiService.hwGroups.getProxyServers(params),
  mapItem: (item) => item,
};

export const ARCHCORE_SOURCE = {
  fetch: (params) => ApiService.hwGroups.getDvrServers(params),
  mapItem: (item) => ({ id: item.id, name: item.server_domain }),
};

export const ARCHCASTER_SOURCE = {
  fetch: (params) => ApiService.archiveCasters.getList(params),
  mapItem: (item) => ({ id: item.id_archive_caster || item.id, name: item.name }),
};
